import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import Home from "./pages/Home";
import Delivery from "./pages/Delivery";
import FAQ from "./pages/FAQ";
import ContactUs from "./pages/ContactUs";
import HowToOrder from "./pages/HowToOrder";
import UKProductList from "./pages/UKProductList";
import Supplies from "./pages/Supplies";
import Admin from "./pages/admin/Admin";

function App() {
  return (
    <div className="container">
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/howtoorder" element={<HowToOrder />} />
          <Route path="/ukproductlist" element={<UKProductList />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/supplies" element={<Supplies />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
